export const SECTIONS = [
  {
    id: 'business', title: 'Business Context', icon: '🏢',
    subtitle: 'Tell us about your organisation',
    fields: [
      { key: 'companyName',   label: 'Company Name',   type: 'text',  required: true },
      { key: 'companyDomain', label: 'Company Domain', type: 'text',  required: true, placeholder: 'e.g. acme.com' },
      { key: 'contactName',   label: 'Your Name',      type: 'text',  required: true },
      { key: 'contactEmail',  label: 'Work Email',     type: 'email', required: true },
      { key: 'companyIndustry', label: 'Company Industry', type: 'chips', required: true,
        options: ['Financial Services','Healthcare','Technology','Manufacturing','Retail','Professional Services','Government','Education','Other'] },
      { key: 'companySize', label: 'Company Size', type: 'chips', required: true,
        options: ['1-50 employees','51-200 employees','201-1000 employees','1001-5000 employees','5000+ employees'] },
      { key: 'annualRevenue', label: 'Annual Revenue', type: 'chips', required: true,
        options: ['Less than $1M','$1M - $10M','$10M - $50M','$50M - $200M','$200M - $1B','$1B+'] },
      { key: 'geographicPresence', label: 'Geographic Presence', type: 'chips', required: true,
        options: ['Single Country','Regional','Multi-Regional','Global'] },
      { key: 'regulatoryEnvironment', label: 'Regulatory Environment', type: 'chips', required: true,
        options: ['GDPR','CCPA/CPRA','HIPAA','SOX','PCI DSS','NIST','Other'] },
      { key: 'existingSecurity', label: 'Existing Security Certifications', type: 'chips', required: false,
        options: ['ISO 27001','SOC 2','NIST Framework','Internal Controls','None'] },
    ]
  },
  {
    id: 'model', title: 'Model Details', icon: '🤖',
    subtitle: 'Describe your AI model configuration',
    fields: [
      { key: 'modelBase', label: 'Model Base', type: 'chips', required: true,
        options: ['GPT-4','GPT-3.5','Claude-3','LLaMA/Open Weights','Custom/Other','Open Source'] },
      { key: 'modelType', label: 'Model Type', type: 'chips', required: true,
        options: ['Text Generation','Code Generation','Multi-modal','Function Calling','Tool Use','RAG'] },
      { key: 'modelProvider', label: 'Model Provider', type: 'chips', required: true,
        options: ['OpenAI','Anthropic','Google','Self-hosted','Other'] },
      { key: 'modelDeployment', label: 'Model Deployment', type: 'chips', required: true,
        options: ['Public Cloud','Private Cloud','On-Premise','Hybrid'] },
      { key: 'modelAccess', label: 'Model Access', type: 'chips', required: true,
        options: ['Public','Internal Only','Selected Users','API Only','Restricted Access'] },
    ]
  },
  {
    id: 'data', title: 'Data Security', icon: '🔐',
    subtitle: 'How is your data protected?',
    fields: [
      { key: 'dataPrivacy', label: 'Data Privacy', type: 'chips', required: true,
        options: ['No PII','Basic PII','Sensitive PII','Healthcare','Financial','Biometric',"Children's Data"] },
      { key: 'dataRetention', label: 'Data Retention', type: 'chips', required: true,
        options: ['No Retention','24 Hours','7 Days','30 Days','90+ Days'] },
      { key: 'dataEncryption', label: 'Data Encryption', type: 'chips', required: true,
        options: ['AES-256','AES-256-GCM','ChaCha20-Poly1305','AES-128','None'] },
      { key: 'dataVectorEncryption', label: 'Data Vector Encryption', type: 'chips', required: true,
        options: ['Encrypted DB with Key Rotation','Encrypted DB','Secure Vector DB','Plain Storage','None'] },
      { key: 'dataKeyManagement', label: 'Data Key Management', type: 'chips', required: true,
        options: ['HSM with Auto-Rotation','HSM','Cloud KMS','Software KMS','None'] },
      { key: 'dataLocation', label: 'Data Location', type: 'chips', required: true,
        options: ['US Only','EU','Global','Custom Region'] },
      { key: 'piiHandling', label: 'PII Handling', type: 'chips', required: true,
        options: ['Automated Redaction','Manual Review','No PII Allowed','No Controls'] },
    ]
  },
  {
    id: 'safety', title: 'Safety Controls', icon: '🛡️',
    subtitle: 'What guardrails do you have in place?',
    fields: [
      { key: 'safetyGuardrails', label: 'Safety Guardrails', type: 'chips', required: true,
        options: ['AI-Powered Defense','Multi-layer Defense','Advanced Filtering','Input Validation','Basic Sanitization','No Controls'] },
      { key: 'contentFiltering', label: 'Content Filtering', type: 'chips', required: true,
        options: ['Basic','Advanced','Custom','None'] },
      { key: 'promptInjection', label: 'Prompt Injection Protection', type: 'chips', required: true,
        options: ['AI-Powered Detection','Advanced Filtering','Basic Validation','None'] },
      { key: 'outputValidation', label: 'Output Validation', type: 'chips', required: true,
        options: ['None','Basic Filtering','Content Policy','Advanced Scanning','Human Review'] },
      { key: 'humanOversight', label: 'Human Oversight', type: 'chips', required: true,
        options: ['Full Trace + AI Validation','Full Trace + Validation','Full Trace','Key Steps','Outcomes Only','None'] },
    ]
  },
  {
    id: 'monitoring', title: 'Monitoring & Compliance', icon: '📡',
    subtitle: 'How do you observe and govern your AI?',
    fields: [
      { key: 'monitoringLogging', label: 'Monitoring & Logging', type: 'chips', required: true,
        options: ['AI-Powered + Real-time','Federated Monitoring','Real-time Monitoring','Basic Logging','No Monitoring'] },
      { key: 'auditTrail', label: 'Audit Trail', type: 'chips', required: true,
        options: ['Complete','Partial','Basic','None'] },
      { key: 'incidentResponse', label: 'Incident Response', type: 'chips', required: true,
        options: ['Automated + AI','Automated','Semi-Automated','Manual','Basic','None'] },
      { key: 'complianceFramework', label: 'Compliance Framework', type: 'chips', required: true,
        options: ['Country Specific AI Act Compliance','SOC2','ISO27001','GDPR','HIPAA','PCI-DSS','CCPA','NIST AI','Other'] },
      { key: 'testingValidation', label: 'Testing & Validation', type: 'chips', required: true,
        options: ['Regular','Periodic','Ad-hoc','None'] },
    ]
  },
  {
    id: 'impact', title: 'Business Impact', icon: '💼',
    subtitle: 'How is AI integrated into your business?',
    fields: [
      { key: 'useCase', label: 'Primary Use Case', type: 'chips', required: true,
        options: ['Customer Service','Internal Tools','Product Feature','Research','Other','No LLM usage'] },
      { key: 'dataSensitivity', label: 'Data Sensitivity', type: 'chips', required: true,
        options: ['Public','Internal','Confidential','Restricted'] },
      { key: 'userScope', label: 'User Scope', type: 'chips', required: true,
        options: ['Internal Employees','Contractors','Customers','Partners','Public'] },
      { key: 'integrationLevel', label: 'Integration Level', type: 'chips', required: true,
        options: ['Standalone System','Partial Integration','Core System Integration','Full Integration'] },
    ]
  },
  {
    id: 'governance', title: 'Agent Governance', icon: '⚙️',
    subtitle: 'How autonomous is your AI system?',
    fields: [
      { key: 'modelTrainingDataScope', label: 'Model Training Data Scope', type: 'chips', required: true,
        options: ['Public Data Only','Licensed Data','Proprietary Data','Mixed Sources','Real-time Data'] },
      { key: 'agentAutonomyLevel', label: 'Agent Autonomy Level', type: 'chips', required: true,
        options: ['Read-only','Limited Safe Actions','Full read-write Access','No Autonomy'] },
      { key: 'agentActionsAudit', label: 'Agent Actions Audit', type: 'chips', required: true,
        options: ['Full Trace + AI Monitoring','Granular + AI Monitoring','Granular Per-Action','Per-Category','Binary','None'] },
      { key: 'userPromptStorage', label: 'User Prompt Storage', type: 'chips', required: true,
        options: ['Session-only','Limited','Permanent','Unmanaged'] },
      { key: 'biasFairnessMitigation', label: 'Bias & Fairness Mitigation', type: 'chips', required: true,
        options: ['Active Testing','Passive Monitoring','None','Under Consideration'] },
    ]
  }
];
